import { Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../../../../components/checkbox/Checkbox";
import CustomInput from "../../../../../../../components/customInput/CustomInput";
import CustomTextarea from "../../../../../../../components/CustomTextarea/CustomTextarea";
import RadioChoices from "../../../../../../../components/radioChoices/RadioChoices";
import CoursePick from "../../../../OdobrenjeAplikacija/PostKomentar/CoursePick";
import styles from "../EnrollmentForm.module.css";
import UserInfo from "../UserInfo";

function EORForm({
  userId,
  formMethodsTwo,
  handleResetForm,
  programApplicationId,
  applicationsCreated,
  evidentionUserID,
  isAccepted,
  application,
  commentModal,
  fetchApplicationCallback,
}) {
  const navigate = useNavigate();
  const getCourseContext = (course) => {
    return {
      userId,
      application,
      commentModal,
      course,
      evidentionUserID,
      fetchApplicationCallback,
    };
  };
  return (
    <div>
      <div className={styles.formInputsContainer}>
        {userId !== "Polaznik" && (
          <UserInfo
            evidentionUserID={
              evidentionUserID ? evidentionUserID : application?.userId
            }
            course={"eOR"}
          />
        )}
        <p className={styles.formSectionText}>
          Ispunjavanje ove aplikacije izražavaš svoj interes za upis 4-godišnjeg
          online programa Osobni razvoj, kao 2. stupnja i temeljnog dijela
          edukacije u školi Integralne tjelesne psihoterapije.
          <br /> Za upis Osobni razvoj-hibrid (eOR) potrebno je: sudjelovanje na
          minimalno 6 radionica, napisane sve introspekcije RAR-a, završen min.
          stupanj stručne spreme Baccalaureus ili više, suglasnost voditelja
          grupe za upis programa
        </p>
        <Controller
          control={formMethodsTwo.control}
          name="question1"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomTextarea
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="question1"
              labelText="Opiši svoje trenutno radno mjesto"
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["eOR"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="question2"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="question2"
              labelText="Navedi ako imaš dosadašnje iskustvo u savjetodavnim, psihoterapijskim ili sličnim edukacijama za rad s ljudima kao i u neposrednom stručnom radu s ljudima:"
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["eOR"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="question3"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="question3"
              labelText="Navedi ako imaš svoja osobna iskustva u radu na sebi i psihoterapiji."
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["eOR"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="question4"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomTextarea
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="question4"
              labelText="Opiši kratko što je tvoja motivacija za upis eOR-a."
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["eOR"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="choice"
          render={({ field: { onChange, onBlur, value } }) => (
            <RadioChoices
              name="choice"
              onBlur={onBlur}
              onChange={
                userId !== "Referada" &&
                !programApplicationId &&
                !evidentionUserID &&
                !applicationsCreated["eOR"]
                  ? onChange
                  : undefined
              }
              value={value}
              disabled={applicationsCreated["eOR"] || evidentionUserID}
              title="Da li je tvoja namjera dolaziti 1x godišnje na modul uživo u Zagreb?"
              choices={["Da", "Ne"]}
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="question5"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="question5"
              labelText="Da li već sada znaš da namjeravaš upisati trening za psihoterapeute ITP-a koji počinje na 3. godini s programom TP i nastavlja se na petoj i šestoj godini s programom TT."
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["eOR"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="question6"
          render={({ field: { onChange, onBlur, value } }) => (
            <CustomInput
              onBlur={onBlur}
              onChange={onChange}
              value={value}
              name="question6"
              labelText="Ovdje možeš upisati svoju napomenu ili eventualno dodatno pitanje"
              placeholder="Upiši"
              disabled={
                userId === "Referada" ||
                programApplicationId ||
                applicationsCreated["eOR"] ||
                evidentionUserID
              }
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="check1"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              onBlur={onBlur}
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              value={value}
              disabled={applicationsCreated["eOR"] || evidentionUserID}
              name="check1"
              label="Ovime potvrđujem da nemam trenutno nikakvo fizičko ili psiho-emocionalno stanje koje bi moglo biti u kontraindikaciji s programom Osobni razvoj.U slučaju da se pitaš da li je neko tvoje fizičko ili psiho-emocionalno stanje ili neki lijekovi koje uzimaš u kontraindikaciji sa upisom OR-a javi nam se na referada@ipd-center.eu kako bi dogovorili evaluacijsku terapiju s voditeljem grupe OR-a."
            />
          )}
        />
        <Controller
          control={formMethodsTwo.control}
          name="check2"
          render={({ field: { onChange, onBlur, value } }) => (
            <Checkbox
              onBlur={onBlur}
              onChange={
                userId !== "Referada" && !programApplicationId && onChange
              }
              disabled={applicationsCreated["eOR"] || evidentionUserID}
              value={value}
              name="check2"
              label="Ovime potvrđujem da u ovoj fazi života (ukoliko ne dođe do nekih nepredviđenih okolnosti) sam u mogućnosti financirati pohađanje programa četverogodišnji Osobni razvoj i potrebne individualne terapije"
            />
          )}
        />
      </div>
      {userId !== "Referada" && !programApplicationId && !evidentionUserID && (
        <div className={styles.formButtonsContainer}>
          {!applicationsCreated["eOR"] && (
            <div
              className={
                userId === "Referada"
                  ? `${styles.disabled} ${styles.cancelButton}`
                  : styles.cancelButton
              }
              onClick={() => {
                if (userId !== "Referada") {
                  formMethodsTwo.reset();
                  navigate(-1);
                }
              }}
              disabled={true}
            >
              odustani
            </div>
          )}
          <div
            className={
              userId === "Referada" || applicationsCreated["eOR"]
                ? `${styles.disabled} ${styles.sendButton}`
                : styles.sendButton
            }
            onClick={() => {
              if (userId !== "Referada") handleResetForm(formMethodsTwo);
            }}
            disabled={applicationsCreated["eOR"]}
          >
            {applicationsCreated["eOR"] ? "Poslano" : "Pošalji prijavu"}
          </div>
        </div>
      )}
      {userId === "Polaznik" &&
        !evidentionUserID &&
        !programApplicationId &&
        applicationsCreated["eOR"] && (
          <>
            {isAccepted["eOR"] !== false && (
              <div
                className={styles.acceptanceContainer}
                style={{
                  backgroundColor:
                    isAccepted["eOR"] === true &&
                    commentModal["eOR"]?.isReferadaAccepted === true
                      ? "#e8fee8"
                      : "#F8F9FB",
                }}
              >
                {isAccepted["eOR"] === true &&
                commentModal["eOR"]?.isReferadaAccepted === true
                  ? "Primljeni ste"
                  : "Vaša aplikacija je zaprimljena"}
              </div>
            )}
          </>
        )}
      {userId !== "Polaznik" && (
        <CoursePick context={getCourseContext("eOR")} />
      )}{" "}
    </div>
  );
}

export default EORForm;
